import Button from "components/button";
import HeroSection from "components/hero-section";

import { faqData } from "./data";

export default function TableOfContents() {
  return (
    <div className="bg-gray-100">
      <HeroSection>
        <HeroSection.Content className="text-left">
          <p>
            Enerflo is the <strong>all-in-one operations platform for residential solar companies</strong>, helping
            Sales Dealers, Master Dealers, Installers, EPCs, and Hybrid/Vertically Integrated companies streamline
            sales, installation, financing, and customer communication.
          </p>

          <br />

          <nav className="space-y-10">
            <ul className="space-y-4 md:columns-2 gap-6 leading-snug">
              {faqData.map(section => (
                <li key={section.id}>
                  <Button href={`#${section.id}`} variant="link">
                    {section.title}
                  </Button>
                </li>
              ))}
            </ul>
          </nav>
        </HeroSection.Content>
      </HeroSection>
    </div>
  );
}
